import { reactive } from 'vue'

// Shared between registerServiceWorker.js (which detects a new version) and
// AppUpdateBanner.vue (which lets the user apply it on their own terms).
export const appUpdateState = reactive({
  updateAvailable: false,
  updating: false,
  registration: null
})

let reloaded = false
function reloadOnce () {
  if (reloaded) return
  reloaded = true
  window.location.reload()
}

export function setUpdateAvailable (registration) {
  appUpdateState.registration = registration
  appUpdateState.updateAvailable = true
}

// Only reload when the controller change was triggered by our own
// "Update Now" click, never on an incidental controllerchange event.
export function handleControllerChange () {
  if (appUpdateState.updating) {
    reloadOnce()
  }
}

export function applyUpdate () {
  appUpdateState.updating = true

  const waiting = appUpdateState.registration && appUpdateState.registration.waiting
  if (!waiting) {
    reloadOnce()
    return
  }

  waiting.postMessage({ type: 'SKIP_WAITING' })
  // Safety net in case controllerchange never fires.
  setTimeout(reloadOnce, 4000)
}
